var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogVisible)?_c('customDialog',{attrs:{"title":'活畜交易近六月价格变化',"visible":_vm.dialogVisible,"width":"60%"},on:{"close":_vm.onClose},scopedSlots:_vm._u([{key:"dialogBody",fn:function(){return [_c('div',{attrs:{"id":"lineChart"}})]},proxy:true}],null,false,2280300872)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }